<div [appAnimate]="'fadeIn'" [once]="true" [speed]="'faster'" class="app-mod">
  <div class="app-mod__hea">
    <span class="app-mod__hea--clo" (click)="close()"></span>
  </div>
  <div class="app-mod__bod">
    <img
      ngSrc="assets/images/form/receipt.webp"
      class="receipt"
      alt="receipt"
      height="694"
      width="680"
    />
  </div>
</div>
